export default __webpack_public_path__ + "static/media/header__logo.6a0a6fc2.svg";